/**
 * 严重表格设置是否符合传入要求
 */
export const validateSettings = (v) => {
  const isBool = typeof v === 'boolean'
  if (isBool) {
    return true
  }
  const isPlain = typeof v === 'object'
  const keys = Object.keys(v)
  return (
    isPlain &&
    keys.every((key) => ['align', 'border', 'size', 'fullScreen', 'columns'].includes(key))
  )
}
// 表格大小传参验证
export const validateSize = (v) => {
  return ['small', 'medium', 'mini'].includes(v)
}
